<script lang="ts" setup>
const { vertical = false } = defineProps<{
  vertical?: boolean
}>()
</script>

<template>
  <div
    v-if="vertical"
    class="w-[1px] bg-[#DCDEE5]"
    data-test="vertical-divider"
  />
  <div
    v-else
    class="border-b border-general-medium"
    data-test="horizontal-divider"
  />
</template>
